<template>
  <!-- MBR052 Heritage Hearth filter sheet (same shell as Filter.vue) -->
  <div
    class="modal modal-bottom fade"
    id="bottom_modal_filter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="bottom_modal_filter"
    style="z-index: 10000"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content mbr-sheet">
        <div class="mbr-sheet__top">
          <span class="mbr-sheet__handle" aria-hidden="true"></span>
          <!-- keep .x-close: MyTransactions / Admissions close the sheet with $(".x-close").click() -->
          <button
            type="button"
            class="x-close mbr-sheet__close"
            data-bs-dismiss="modal"
            :aria-label="$t('common.close')"
          >
            <svg fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
          </button>
        </div>

        <div class="mbr-sheet__head">
          <h2 class="mbr-sheet__title">{{ $t('filter_transaction.title') }}</h2>
          <button type="button" class="x-reset mbr-sheet__reset" @click="resetData()">
            {{ $t('common.reset') }}
          </button>
        </div>

        <!-- MBR108 the API applies status and months to Wallet/Point only, so Receipt shows stores alone -->
        <section v-if="!storesOnly" class="mbr-sheet__group">
          <h3 class="mbr-sheet__label">{{ $t('filter_transaction.status') }}</h3>
          <div class="mbr-sheet__chips">
            <button
              type="button"
              class="mbr-sheet__chip"
              :class="{ 'mbr-sheet__chip--on': isStatusAll }"
              @click="checkAllStatus(true), filterCashbackType(idStatus)"
            >
              {{ $t('common.all') }}
            </button>
            <button
              v-for="(value, index) in statusText"
              :key="index"
              type="button"
              class="mbr-sheet__chip"
              :class="{ 'mbr-sheet__chip--on': idStatus.includes(index) }"
              @click="checkStatus(index), filterCashbackType(idStatus)"
            >
              {{ value }}
            </button>
          </div>
        </section>

        <section v-if="stores.length" class="mbr-sheet__group">
          <h3 class="mbr-sheet__label">{{ $t('filter_transaction.stores') }}</h3>
          <div class="mbr-sheet__chips">
            <!-- selected state used to be painted by jQuery .css(); it now follows the host's array -->
            <button
              v-for="(value, index) in stores"
              :key="index"
              type="button"
              class="mbr-sheet__chip"
              :class="{ 'mbr-sheet__chip--on': (filterArrStore || []).includes(value.id) }"
              @click="filterStore(value.id)"
            >
              {{ value.branch_name }}
            </button>
          </div>
        </section>

        <section v-if="!storesOnly" class="mbr-sheet__group">
          <h3 class="mbr-sheet__label">{{ $t('filter_transaction.months') }}</h3>
          <div class="mbr-sheet__chips">
            <button
              v-for="time in cashbackTimes"
              :key="time.value"
              type="button"
              class="mbr-sheet__chip"
              :class="{ 'mbr-sheet__chip--on': filterCashbackTimeSelected === time.value }"
              @click="filterCashbackTime(time.value)"
            >
              {{ time.label }}
            </button>
          </div>
        </section>

        <button type="button" class="mbr-sheet__apply" @click="filterData()">
          {{ $t('common.apply') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RewardService from "../services/reward.service";
import { errorMessage } from "@/utils/errorMessage";
export default {
  name: "Exchange",
  data() {
    return {
      stores: [],
      idStatus: [],
      isStatusAll: false,
      loaderActive: false,
      isLoadDone: false,
    };
  },
  computed: {
    // index = filter_cashback_earn_status value sent to the API (0 pending, 1 confirmed)
    statusText() {
      return [this.$t('filter_transaction.pending'), this.$t('filter_transaction.confirmed')];
    },
    // filter_cashback_time values, same order as before; only the labels are translated
    cashbackTimes() {
      return [
        { value: 0, label: this.$t('common.all') },
        { value: 1, label: this.$t('filter_transaction.one_day') },
        { value: 2, label: this.$t('filter_transaction.one_week') },
        { value: 3, label: this.$t('filter_transaction.one_month') },
        { value: 4, label: this.$t('filter_transaction.three_months') },
        { value: 5, label: this.$t('filter_transaction.one_year') },
      ];
    },
  },
  created() {
    this.getBranches();
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    filterCashbackType: {
      type: Function,
      default: () => { },
    },
    filterStore: {
      type: Function,
      default: () => { },
    },
    filterArrStore: {
      type: Array
    },
    filterArrCashbackEarnStatus: {
      type: Array,
      default: () => [],
    },
    filterCashbackTimeSelected: {
      type: Number,
      default: null,
    },
    filterCashbackTime: {
      type: Function,
      default: () => { },
    },
    filterData: {
      type: Function,
      default: () => { },
    },
    resetData: {
      type: Function,
      default: () => { },
    },
    storesOnly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    // Reset empties the host's array; clear the local status chips with it
    // (they used to stay highlighted after a reset)
    filterArrCashbackEarnStatus(value) {
      if (!value || !value.length) {
        this.idStatus = [];
        this.isStatusAll = false;
      }
    },
  },
  methods: {
    getBranches() {
      this.stores = [];
      this.showLoader();
      RewardService.getBranches().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.stores = response.data.data;
          } else {
            this.snackbar = "danger";
            this.message = errorMessage(response.data.result.message);
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = errorMessage(error);
          this.hideLoader();
        }
      );
    },

    checkStatus(statusId = "") {
      if (statusId >= 0) {
        if (this.idStatus.includes(statusId)) {
          this.deleteStatus(statusId);
        } else {
          this.idStatus.push(statusId);
        }
      }
      this.checkAllStatus();
    },
    deleteStatus(statusId = "") {
      this.idStatus.forEach((value, index) => {
        if (value == statusId) {
          this.idStatus.splice(index, 1);
        }
      });
    },

    checkAllStatus(isAll = false) {
      if (isAll) {
        this.isStatusAll = !this.isStatusAll;
        if (this.isStatusAll) {
          this.idStatus = [0, 1];
        } else {
          this.idStatus = [];
        }
      } else {
        if (this.idStatus.length == 2) {
          this.isStatusAll = true;
        } else {
          this.isStatusAll = false;
        }
      }
    },

    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
  },
};

</script>
<style scoped>
/* MBR033 follow-up — Heritage Hearth bottom sheet, same shell as the member QR sheet.
   Doubled with .modal.modal-bottom to outrank the square corners set below */
.modal.modal-bottom .modal-content.mbr-sheet {
  padding: 12px 20px 24px;
  background: var(--mbr-color-canvas);
  border: 0;
  border-top: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: 32px 32px 0 0;
  box-shadow: var(--mbr-shadow-modal);
  font-family: var(--mbr-font-body);
  max-height: 88vh;
  overflow-y: auto;
}

/* Store/RewardCatalogue load an unscoped `* { font-family: Poppins }` app-wide */
.mbr-sheet :where(:not(.material-icons-round)) {
  font-family: var(--mbr-font-body);
}

.mbr-sheet__top {
  position: relative;
  display: flex;
  justify-content: flex-end;
  min-height: 36px;
}

.mbr-sheet__handle {
  position: absolute;
  top: 0;
  left: 50%;
  width: 40px;
  height: 4px;
  background: var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  transform: translateX(-50%);
}

.mbr-sheet__close {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  padding: 0;
  background: var(--mbr-color-tint);
  border: 1px solid rgba(var(--mbr-color-outline-rgb), 0.5);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-secondary);
  transition: transform 0.12s ease;
}

.mbr-sheet__close:active {
  transform: scale(0.95);
}

.mbr-sheet__close:focus-visible {
  outline: 2px solid var(--mbr-color-primary);
  outline-offset: 2px;
}

.mbr-sheet__close svg {
  width: 16px;
  height: 16px;
}

.mbr-sheet__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-sheet__title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: 20px;
  font-weight: 800;
  line-height: 26px;
  letter-spacing: -0.015em;
  color: var(--mbr-color-ink-headline);
}

.mbr-sheet__apply {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 52px;
  margin-top: 20px;
  padding: 0;
  background: var(--mbr-color-primary);
  border: 0;
  border-radius: var(--mbr-radius-full);
  font-family: var(--mbr-font-headline);
  font-size: 15px;
  font-weight: 800;
  line-height: 20px;
  color: var(--mbr-color-on-primary);
  box-shadow: var(--mbr-shadow-card);
  transition: transform 0.12s ease;
}

.mbr-sheet__apply:active {
  transform: scale(0.99);
}

.mbr-sheet__reset {
  padding: 0;
  background: none;
  border: 0;
  font-family: var(--mbr-font-headline);
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  color: var(--mbr-color-primary);
}

.mbr-sheet__group {
  margin-top: 18px;
}

.mbr-sheet__label {
  margin: 0 0 10px;
  font-family: var(--mbr-font-headline);
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.08em;
  color: var(--mbr-color-ink-muted);
  text-transform: uppercase;
}

.mbr-sheet__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mbr-sheet__chip {
  padding: 8px 14px;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  color: var(--mbr-color-ink-secondary);
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.mbr-sheet__chip--on {
  background: var(--mbr-color-primary);
  border-color: var(--mbr-color-primary);
  font-weight: 700;
  color: var(--mbr-color-on-primary);
}


/* Css model */
.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog,
.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  -webkit-transform: translate3d(0%, 0, 0);
  -ms-transform: translate3d(0%, 0, 0);
  -o-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

/* Left & Right */

.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog {
  position: fixed;
  margin: auto;
  width: 500px;
  max-width: 100%;
  height: 100%;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-left .modal-body,
.modal.modal-right .modal-body {
  padding: 15px 15px 80px;
}

.modal.modal-left.fade .modal-dialog {
  left: -500px;
  -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
  -o-transition: opacity 0.3s linear, left 0.3s ease-out;
  transition: opacity 0.3s linear, left 0.3s ease-out;
}

.modal.modal-left.fade.show .modal-dialog {
  left: 0;
}

.modal.modal-right.fade .modal-dialog {
  right: -500px;
  -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
  -o-transition: opacity 0.3s linear, right 0.3s ease-out;
  transition: opacity 0.3s linear, right 0.3s ease-out;
}

.modal.modal-right.fade.show .modal-dialog {
  right: 0;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content,
.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content,
.modal.modal-full .modal-content {
  border-radius: 0;
  border: none;
}

.modal.modal-left .modal-dialog.modal-sm,
.modal.modal-right .modal-dialog.modal-sm {
  width: 300px;
}

.modal.modal-left .modal-dialog.modal-lg,
.modal.modal-right .modal-dialog.modal-lg {
  width: 800px;
}

.modal.modal-left .modal-dialog.modal-xl,
.modal.modal-right .modal-dialog.modal-xl {
  width: 1140px;
}

/* Top and Bottom */

.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
}

.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content {
  height: auto;
  overflow: hidden;
}

.modal.modal-top .modal-body,
.modal.modal-bottom .modal-body {
  padding: 15px 15px;
  overflow-y: auto;
  max-height: 60vh;
}

/* Top */

.modal.modal-top.fade .modal-dialog {
  top: -100%;
  -webkit-transition: opacity 0.3s linear, top 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, top 0.3s ease-out;
  -o-transition: opacity 0.3s linear, top 0.3s ease-out;
  transition: opacity 0.3s linear, top 0.3s ease-out;
}

.modal.modal-top.fade.show .modal-dialog {
  top: 0;
}

/* Bottom */

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  -webkit-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -o-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
}

/* Full Screen */

.modal.modal-full .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: 100%;
}

.modal.modal-full .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-full .close-modal {
  position: fixed;
  top: 0;
  right: 3rem;
}

/* Footer */

.modal-footer-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: var(--mbr-color-surface);
  border-radius: 0;
}

/* XS */

.modal.modal-left.xs .modal-body,
.modal.modal-right.xs .modal-body {
  padding: 15px;
}
</style>
